import "./formButton.scss";

import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import keyConstants from "../../constants/keyConstants";
import preprocessorQuery from "../../utils/preprocessorQuery";
import Icon from "../interface/Icon";
import onPulseAnimationEnd from "../onPulseAnimationEnd";

const FormButton = forwardRef((props, ref) => {
  const isIos = preprocessorQuery.isIos();

  const style = Object.assign(
    {
      fontSize: props.fontSize ? `${props.fontSize}px` : null
    },
    props.style ? props.style : {}
  );

  const onKeyDown = e => {
    if (!props.disabled && e.key === keyConstants.Enter && props.onClick) {
      e.stopPropagation();
      e.preventDefault();
      props.onClick(e);
    }
  };

  const classes = [
    "formBtn",
    props.primary ? "primary" : "",
    props.secondary ? "secondary" : "",
    props.linkStyle ? "linkStyle" : "",
    props.destructive ? "destructive" : "",
    props.rightAlign ? "rightAlign" : "",
    props.disabled ? "disabled" : "",
    props.pulse ? "pulse" : "",
    props.allowTextWrap ? "allowTextWrap" : "",
    props.className ? props.className : ""
  ].join(" ");

  const rightIcon = props.rightIcon ? (
    <Icon icon={props.rightIcon} />
  ) : !props.leftIcon && isIos && !props.linkStyle && !props.secondary ? (
    <Icon icon="rightArrow" />
  ) : null;

  return (
    <div
      className={classes}
      onClick={props.disabled ? null : props.onClick}
      style={style}
      id={props.id ? props.id : null}
      tabIndex={!props.disabled && props.canFocus && props.onClick ? 0 : null}
      onKeyDown={onKeyDown}
      title={props.tooltip}
      ref={ref}
      onAnimationEnd={onPulseAnimationEnd}
    >
      {props.leftIcon ? <Icon icon={props.leftIcon} /> : null}
      <span>{props.label}</span>
      {rightIcon}
    </div>
  );
});

FormButton.defaultProps = {
  canFocus: true
};

FormButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  destructive: PropTypes.bool,
  linkStyle: PropTypes.bool,
  rightAlign: PropTypes.bool,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  id: PropTypes.string,
  canFocus: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  tooltip: PropTypes.string,
  pulse: PropTypes.bool,
  allowTextWrap: PropTypes.bool
};

export default FormButton;
